import { functions } from "./firebase";

const CALLABLE_TIMEOUT_MS = 20_000;

export async function reverifyLocationCapabilities({
  locationId,
  diagnosticCapabilities,
  dataFlagId,
}) {
  const callable = functions.httpsCallable("reverifyLocationCapabilities", {
    timeout: CALLABLE_TIMEOUT_MS,
  });
  const response = await callable({
    locationId,
    diagnosticCapabilities,
    ...(dataFlagId ? { dataFlagId } : {}),
  });
  return response?.data || null;
}

